<div class="title-wrap">
  <span>Videos von <a href="https://video.tt.com/" target="_blank">video.tt.com</a></span>
</div>
<div class="video-wrap">
  <div class="frame-wrap">
    <iframe
      [src]="selectedVideo.embedUrl + '?autoplay=1&autoplaymode=default' | sanitizeUrl"
      width="100%"
      height="400"
      allowFullscreen
      *ngIf="iframeVisible; else videoThumb"
    ></iframe>
  </div>
</div>
<div class="text-wrap-default">
  <div class="title">
    {{ selectedVideo.title | decodeHtmlString }}
  </div>
  <div class="grey">
    {{ selectedVideo.unixTimestamp | date : 'short' }}
    <span
      *ngIf="selectedVideo.channel"
      class="logo_{{ selectedVideo.channel | simplifyString }}"
      [innerHTML]="' | ' + selectedVideo.channel"
    ></span>
  </div>
</div>
<nmo-content-slider
  [hasArrowNav]="true"
  [hasPointNav]="false"
  [autoslideOn]="false"
  *ngIf="groups.length > 0"
  (indexChanged)="slideChanged($event)"
  [selectedIndex]="currentSlideIndex"
  [slides]="groups"
>
  <nmo-content-slider-item *ngFor="let group of groups; let gi = index; trackBy: groupTrackBy" [position]="gi">
    <div class="slide">
      <a
        class="inslide-item"
        [ngClass]="{ active: video === selectedVideo, loading: !video }"
        *ngFor="let video of group; let ii = index"
        (click)="selectVideo(gi, ii)"
      >
        <ng-container *ngIf="video">
          <div class="image-wrap">
            <img [src]="video.thumbnail" [alt]="video.title | decodeHtmlString" />
          </div>
          <div class="text-wrap" [innerHTML]="video.title"></div>
        </ng-container>
      </a>
    </div>
  </nmo-content-slider-item>
</nmo-content-slider>

<ng-template #videoThumb>
  <div class="thumb-overlay" (click)="toggleThumb()">
    <img class="thumb" [src]="selectedVideo.thumbnail" [alt]="selectedVideo.title | decodeHtmlString" />
    <div class="icon-overlay"><i class="icon tt-icon-play-2"></i></div>
  </div>
</ng-template>
